/** @format */

import { useEffect } from "react";
import { Container } from "../../components/layouts/Container";
import useGTMHooks from "../../hooks/useGTMHooks";
import EmochiEconomicEstimateElement from "../../components/ui_elements/emochi/Economic/EconomicEstimateElement";

const EmochiRedirectEconomic = ({ redirect }: { redirect?: boolean }) => {
  const { pushDataLayerHandler } = useGTMHooks();
  useEffect(() => {
    pushDataLayerHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container isLogin={true} background={"default"} align={"top"} redirect={redirect}>
      <EmochiEconomicEstimateElement redirect={redirect} />
    </Container>
  );
};

export default EmochiRedirectEconomic;
